import { LICENSE_MODULES } from '../../../../../constants';

import Orders from '../../components/order/orders';
import Employees from '../../components/admin/employees';
import OrderDetails from '../../components/order/order-details';
import SignIn from '../../components/sign-in';
import RestorePassword from '../../components/restore-password';
import CatalogueManagement from '../../components/catalogue-management/catalogue-management';
import Customers from '../../components/base-data/customers/customers';
import Articles from '../../components/base-data/articles/articles';
import ArticleDescriptions from '../../components/base-data/articles/article-descriptions';
import ArticleKeywords from '../../components/base-data/articles/article-keywords';
import ArticleKeywordStructure from '../../components/base-data/articles/article-keyword-structure';
import ArticleKeywordAssignment from '../../components/base-data/articles/article-keyword-assignment';
import ArticlePictures from '../../components/base-data/articles/article-pictures';
import ArticleAlternatives from '../../components/base-data/articles/article-alternatives';
import AppointmentGrid from '../../components/base-data/articles/appointment-grid';
import QuantityScale from '../../components/base-data/articles/quantity-scale';
import PriceList from '../../components/base-data/price-list/price-list';
import Import from '../../components/import/import';
import ExportOrders from '../../components/export-orders/export-orders';
import Stocks from '../../components/base-data/stocks/stocks';
import Statistics from '../../components/statistics/statistics';
import CustomerStatistics from '../../components/base-data/customers/statistics';
import Conditions from '../../components/base-data/customers/conditions';

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/dashboard',
    meta: {
      title: '',
      requiresAuth: true,
      module: LICENSE_MODULES.RPTRADE,
      roles: '*'
    }
  },
  {
    path: '/anmelden',
    name: 'sign-in',
    component: SignIn,
    meta: {
      title: 'sign_in',
      requiresAuth: false,
      roles: '*'
    }
  },
  {
    path: '/restore-password',
    name: 'restore-password',
    component: RestorePassword,
    meta: {
      title: 'restore_password',
      requiresAuth: false,
      roles: '*'
    }
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders,
    meta: {
      title: 'order_intake',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/order/:id',
    name: 'order-details',
    component: OrderDetails,
    meta: {
      title: 'order',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/employees',
    name: 'employees',
    component: Employees,
    meta: {
      title: 'users_and_devices',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/sales-catalogues',
    name: 'sales-catalogues',
    component: CatalogueManagement,
    meta: {
      title: 'sales_catalogues',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: {
      title: 'customers',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/customer-statistics',
    name: 'customer-statistics',
    component: CustomerStatistics,
    meta: {
      title: 'customer_statistics',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/conditions',
    name: 'conditions',
    component: Conditions,
    meta: {
      title: 'conditions',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/articles',
    name: 'articles',
    component: Articles,
    meta: {
      title: 'article',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/article-descriptions',
    name: 'article_descriptions',
    component: ArticleDescriptions,
    meta: {
      title: 'article_descriptions',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/article-keywords',
    name: 'article_keywords',
    component: ArticleKeywords,
    meta: {
      title: 'article_keywords',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/article-keyword-structure',
    name: 'article_keyword_structures',
    component: ArticleKeywordStructure,
    meta: {
      title: 'article_keyword_structures',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/article-keyword-assignment',
    name: 'article_keyword_assignments',
    component: ArticleKeywordAssignment,
    meta: {
      title: 'article_keyword_assignments',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/article-pictures',
    name: 'article_pictures',
    component: ArticlePictures,
    meta: {
      title: 'article_pictures',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/article-alternatives',
    name: 'article_alternatives',
    component: ArticleAlternatives,
    meta: {
      title: 'article_alternatives',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/appointment-grid',
    name: 'appointment_grid',
    component: AppointmentGrid,
    meta: {
      title: 'appointment_grid',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/quantity-scale',
    name: 'quantity_scale',
    component: QuantityScale,
    meta: {
      title: 'quantity_scale',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/stocks',
    name: 'stocks',
    component: Stocks,
    meta: {
      title: 'stocks',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/pricelist',
    name: 'pricelist',
    component: PriceList,
    meta: {
      title: 'price_list',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/import',
    name: 'import',
    component: Import,
    meta: {
      title: 'import',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/export',
    name: 'export',
    component: ExportOrders,
    meta: {
      title: 'export',
      requiresAuth: true,
      roles: '*'
    }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: Statistics,
    meta: {
      title: 'statistics',
      requiresAuth: true,
      roles: '*'
    }
  }
];

export default routes;
